import React, { useState, useEffect } from 'react';
import CustomSelect from '../../../../components/CustomSelect/CustomSelect';
import SlotMapping from '../../../../types/BotBuilder/SlotMapping';

interface EnumeratedValueInputProps {
  selectedSlot: any;
  mapping: SlotMapping;
  index: number;
  targetIntentDetails: any;
  updateSlotValue: (index: number, value: string) => void;
  disabled?: boolean;
}

function EnumeratedValueInput({
  selectedSlot,
  mapping,
  index,
  targetIntentDetails,
  updateSlotValue,
  disabled = false
}: EnumeratedValueInputProps): React.ReactElement {
  const [filteredOptions, setFilteredOptions] = useState<string[]>([]);

  useEffect(() => {
    if (!selectedSlot?.enumeratedSlotValues) {
      setFilteredOptions([]);
      return;
    }

    if (!targetIntentDetails) {
      setFilteredOptions(
        selectedSlot.enumeratedSlotValues.map(
          (enumValue: any) => enumValue.resolvedValue
        )
      );
      return;
    }

    const elicitSlotStep = targetIntentDetails.responseSteps?.find(
      (step: any) =>
        step.elicitSlotStep?.slotName === mapping.destinationSlotName
    );

    const availableOptions = selectedSlot.enumeratedSlotValues
      .map((enumValue: any) => enumValue.resolvedValue)
      .filter((resolvedValue: string) => {
        if (!elicitSlotStep?.elicitSlotStep) return true;

        const hasNextStep =
          elicitSlotStep.elicitSlotStep.slotConditionals?.some(
            (conditional: any) =>
              conditional.slotValue === resolvedValue &&
              conditional.nextStep !== null
          );

        return hasNextStep;
      });

    setFilteredOptions(availableOptions);
  }, [
    targetIntentDetails,
    mapping.destinationSlotName,
    selectedSlot.enumeratedSlotValues
  ]);

  return (
    <CustomSelect
      value={mapping.slotValue || ''}
      onValueChange={(value) => updateSlotValue(index, value)}
      options={filteredOptions.map((option) => ({
        value: option,
        label: option
      }))}
      placeholder='Select slot value'
      className='bg-white'
      fullWidth
      disabled={disabled}
    />
  );
}

export default EnumeratedValueInput;
